module.exports = __webpack_public_path__ + "fonts/Luscious-Lifestyles-Sans.36577d1c.otf";